import React, { useState } from 'react';
import SectionBasePage from 'components/SectionBasePage';
import { Button } from 'UI';
import { Form } from 'antd';
import { useDispatch } from 'hooks/store';
import { createUserAction } from 'state/slices/users';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { createAlertNotification } from 'infra/notification';
import { AlertNotificationType, setNotificationAction } from 'state/slices/notification';
import { unwrapResult } from '@reduxjs/toolkit';

import AddForm, { AddUserFormData } from './components/AddForm';
import {
  MainContainer,
} from './style';

const UserAddPage = (): JSX.Element => {
  const [form] = Form.useForm<AddUserFormData>();
  const [isLoading, setLoading] = useState(false);
  const navigator = useBreadcrumbNavigation();
  const dispatch = useDispatch();

  const onSaveClick = () => {
    form.submit();
  };

  const onFormSubmit = async (data: AddUserFormData) => {
    setLoading(true);
    try {
      const result = await dispatch(createUserAction(data));
      const createdUser = await unwrapResult(result);
      const successAlert = createAlertNotification(`
        Usuario ${createdUser.name} criado com sucesso.
        As instrucoes para criacao de senha foram enviadas para ${createdUser.email}
      `, AlertNotificationType.Success);
      dispatch(setNotificationAction(successAlert));
      setLoading(false);
      navigator.toPrevious();
    } catch (err) {
      const errorAlert = createAlertNotification('Erro interno ao tentar criar usuario. Tente novamente.', AlertNotificationType.Error);
      dispatch(setNotificationAction(errorAlert));
      setLoading(false);
    }
  };

  return (
    <SectionBasePage
      title="Novo usuário"
      extra={(
        <Button
          loading={isLoading}
          onClick={onSaveClick}
        >
          Salvar usuário
        </Button>
      )}
    >
      <MainContainer>
        <AddForm formHandler={form} onSubmit={onFormSubmit} isLoading={isLoading} />
      </MainContainer>
    </SectionBasePage>
  );
};

export default UserAddPage;
